import React, { FunctionComponent, ReactNode } from 'react';
import AppLayout from '../app-layout/AppLayout';
import * as styles from './ListingLayout.style';
import PageLayout from '../page-layout/PageLayout';
import { BreadcrumbItem } from '../../components/breadcrumb/Breadcrumb';

export interface ListingLayoutProps {
  breadcrumb: BreadcrumbItem[],
  activePage?: string,
  render: {
    header?: () => ReactNode,
    side?: () => ReactNode,
    secondaryNavigation?: () => ReactNode,
  },
  children: ReactNode,
}

const ListingLayout: FunctionComponent<ListingLayoutProps> = ({
  activePage,
  render,
  breadcrumb,
  children,
}) => (
  <AppLayout activePage={activePage}>
    {render.secondaryNavigation && (
      <header css={styles.secondaryNavigation}>
        {render.secondaryNavigation()}
      </header>
    )}
    <PageLayout.Wrapper>
      {render.header && (
        <header css={styles.header}>
          {render.header()}
        </header>
      )}
      <div css={styles.content}>
        <main css={styles.main}>
          {children}
        </main>
        {render.side && (
          <aside css={styles.secondary}>
            {render.side()}
          </aside>
        )}
      </div>
      <PageLayout.Breadcrumb items={breadcrumb} />
    </PageLayout.Wrapper>
  </AppLayout>
);

export default ListingLayout;
